export default "__VITE_ASSET__fac66612__"